import {
  useGetLeaderboard,
  useInvalidateGetRewards,
} from '@wwe-portal/web/providers/queries/rbe';
import { EventData, EventTypeEnum } from '@wwe-portal/entities/rbe.type';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { IcoMoonSpan } from '@wwe-portal/ui/components/icons';
import { useEffect } from 'react';
import { useTimeLeft } from '@wwe-portal/ui/lib/hooks';

import { PlayerLeaderboard } from '../leaderboard/player-leaderboard';
import { PlayerRankData } from '../leaderboard/player-leaderboard.type';

export const GlobalEventLeaderboard = ({ event }: { event: EventData }) => {
  const t = useTranslations();
  const { leaderboard: rawData } = useGetLeaderboard(
    {
      portalEventId: String(event.portalEventId),
      typeId: event.typeId,
    },
    {
      enabled:
        event.typeId !== EventTypeEnum.SOLO || event.leaderboardId != null,
    }
  );

  // Invalidate reward status when event ends to trigger auto-claim modal
  const invalidateGetRewards = useInvalidateGetRewards();
  const { ended } = useTimeLeft(event.endDate);

  useEffect(() => {
    if (ended) {
      invalidateGetRewards();
    }
  }, [ended, invalidateGetRewards]);

  const leaderboard = rawData;
  const data: PlayerRankData[] =
    leaderboard?.rows?.map((row, index) => ({
      points: row.playerPoints,
      rank: index + 1,
      name: row.playerName ?? 'Anonymous',
      faction: row.factionName,
      userId: row.userId,
    })) ?? [];

  const header = (
    <div className="bg-back600 flex items-center gap-2.5 p-5">
      <div className="text-text300 grow text-sm font-medium">
        <div className="flex flex-wrap items-center gap-x-2">
          <h4 className="text-text300 text-xl font-medium">
            {t('global_leaderboard')}
          </h4>
          <div className="text-text600 text-sm font-normal">
            ({t('by_number_of_points')})
          </div>
        </div>
      </div>
      <Link
        href={`/leaderboard/rbe/${event.portalEventId}`}
        className="text-text600 flex shrink-0 grow-0 basis-[100px] items-center gap-2 text-xs"
      >
        <span>{t('see_top_1000')}</span>{' '}
        <IcoMoonSpan iconName="arrow-right" className="text-sm" />
      </Link>
    </div>
  );

  return (
    <PlayerLeaderboard
      compact={false}
      data={data ?? []}
      desktopHeader={header}
      mobileHeader={header}
    />
  );
};
